import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type WatchInvoicePaymentsSubscriptionVariables = Types.Exact<{
  invoiceId: Types.Scalars['bigint']['input'];
}>;


export type WatchInvoicePaymentsSubscription = { __typename?: 'subscription_root', arpayments: Array<{ __typename?: 'arpayments', id: number, status: string, amount: number }> };


export const WatchInvoicePaymentsDocument = gql`
    subscription watchInvoicePayments($invoiceId: bigint!) {
  arpayments(where: {invoice_id: {_eq: $invoiceId}}, order_by: {id: asc}) {
    id
    status
    amount
  }
}
    `;

/**
 * __useWatchInvoicePaymentsSubscription__
 *
 * To run a query within a React component, call `useWatchInvoicePaymentsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWatchInvoicePaymentsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWatchInvoicePaymentsSubscription({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useWatchInvoicePaymentsSubscription(baseOptions: Apollo.SubscriptionHookOptions<WatchInvoicePaymentsSubscription, WatchInvoicePaymentsSubscriptionVariables> & ({ variables: WatchInvoicePaymentsSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<WatchInvoicePaymentsSubscription, WatchInvoicePaymentsSubscriptionVariables>(WatchInvoicePaymentsDocument, options);
      }
export type WatchInvoicePaymentsSubscriptionHookResult = ReturnType<typeof useWatchInvoicePaymentsSubscription>;
export type WatchInvoicePaymentsSubscriptionResult = Apollo.SubscriptionResult<WatchInvoicePaymentsSubscription>;